import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AppService } from '../app.service';
import { CommonModule } from '@angular/common';
import { SvgComponent } from '../svg/svg.component';
import { NibssQrChannelComponent } from '../qr-channel/nibss-qr-channel/nibss-qr-channel.component';
import { VisaQrChannelComponent } from '../qr-channel/visa-qr-channel/visa-qr-channel.component';

@Component({
    selector: 'qr-channel',
    templateUrl: './qr-channel.component.html',
    styleUrls: ['./qr-channel.component.scss'],
    standalone: true,
    imports: [CommonModule, SvgComponent, NibssQrChannelComponent, VisaQrChannelComponent]
})
export class QRChannelComponent implements OnInit, OnChanges {
  @Output() onComplete: any = new EventEmitter<any>();
  @Output() onClose: any = new EventEmitter<any>();
  @Input() activeTab: any = null;
  error: boolean = false;

  qrProviders = [
    {
      title: 'NQR',
      subtitle: 'Pay with NQR',
      icon: 'nqr-icon',
      id: 'nqr',
      isActive: true,
    },
    // {
    //   title: 'VISA QR',
    //   subtitle: 'Pay with VISA QR',
    //   icon: 'visa-icon',
    //   id: 'vqr',
    //   isActive: false,
    // },
  ];

  constructor(
    private cd: ChangeDetectorRef,
    private appService: AppService,
    private el: ElementRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeTab'].currentValue == 'qr') {
      console.log('qr working');
      // this.appService.getData().subscribe({
      //   next: (res) => {
      //     if (res) {
      //       this.transactionData = res.txnData;
      //       this.reference = res.txnRef;
      //       this.transactionFees = res.transactionFees;
      //       this.amount = StringHelper.toMajorAmount(
      //         +this.transactionData.amount + this.transactionFees.WEB_USSD
      //       );
      //     }
      //   },
      //   error: (err) => {
      //     console.log(err);
      //   },
      // });
    }
  }

  ngOnInit(): void {}

  updateSelection(provider: any) {
    console.log(provider);
  }

  checkProvider(provider: any): boolean {
    return this.qrProviders.some(
      (item) => item.isActive && item.id === provider
    );
  }
}
